import { render, staticRenderFns } from "./XieZuoYangBen.vue?vue&type=template&id=ad93db16&scoped=true"
import script from "./XieZuoYangBen.vue?vue&type=script&lang=js"
export * from "./XieZuoYangBen.vue?vue&type=script&lang=js"
import style0 from "./XieZuoYangBen.vue?vue&type=style&index=0&id=ad93db16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad93db16",
  null
  
)

export default component.exports